const camel2title = (camelCase: string) => camelCase
  .replace(/([A-Z])/g, match => ` ${match}`)
  .replace(/^./, match => match.toUpperCase())
  .trim()

export default camel2title
